// src/index.js
import './logger';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './App.tsx';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals.js';
import { ToastProvider } from './context/ToastContext.tsx';
// import { NotificationProvider } from './context/NotificationContext.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <NotificationProvider> */}
    <ErrorBoundary>
      <ToastProvider>
        <AppWrapper />
      </ToastProvider>
    </ErrorBoundary>
    {/* </NotificationProvider> */}
  </React.StrictMode>
);

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('/firebase-messaging-sw.js')
//     .then((reg) => console.log('SW registered, scope:', reg.scope))
//     .catch((err) => console.error('SW registration failed:', err));
// }

reportWebVitals();
